import { Route } from "@angular/router";
import { PainelIndicacaoPage } from "./painel-indicacao.page";

export const PainelIndicacaoRouter: Route[] = [
  { path: 'painel-indicacao', component: PainelIndicacaoPage }
];
